import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairRegistrationSponsorOrHostModalContainerLoadable =
  Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "StaffGradFairRegistrationSponsorOrHostModalContainer" */
        './StaffGradFairRegistrationSponsorOrHostModalContainer.dynamic'
      ),
    loading: LoadingModal,
  });
